import { render, staticRenderFns } from "./RadioStep.vue?vue&type=template&id=5bd0225d&scoped=true&"
import script from "./RadioStep.vue?vue&type=script&lang=ts&"
export * from "./RadioStep.vue?vue&type=script&lang=ts&"
import style0 from "./RadioStep.vue?vue&type=style&index=0&id=5bd0225d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd0225d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
